/* global axios */
import ApiClient from './ApiClient';

class CompanyLabelsAPI extends ApiClient {
  constructor() {
    super('company_labels', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(label) {
    return axios.post(this.url, label);
  }

  update(id, label) {
    return axios.patch(`${this.url}/${id}`, label);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getCompanyLabels(companyId) {
    return axios.get(`${super.baseUrl()}/companies/${companyId}/labels`);
  }

  updateCompanyLabels(companyId, labels) {
    return axios.post(`${super.baseUrl()}/companies/${companyId}/labels`, {
      labels,
    });
  }
}

export default new CompanyLabelsAPI();
